import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useReduxState } from 'hooks';
import { filterValuesSeparator } from 'shared-helpers/consts';
import { PageContent, PageSectionHeader } from 'components/page';
import {
  CoursesHeader,
  CoursesNav,
  CoursesViewAdministered,
  CoursesViewAllCourses,
  CoursesViewAvailable,
  CoursesViewUser
} from '.';

import type { GetCoursesRes } from 'shared-types/responses';

export type CourseInView = GetCoursesRes['courses'][0];

const Courses = () => {
  const { messages, user } = useReduxState();
  const [filterData, setFilterData] = useState(null);

  const router = useRouter();
  const type = router.query.type as string;

  useEffect(() => {
    if (!type) {
      router.replace('/courses?type=all', '/courses?type=all', {
        shallow: true
      });
    }
  }, [type]);

  if (!user || !type) return null;

  const queryParams = Object.keys(router.query)
    .map((param) => {
      const value = router.query[param];
      return Array.isArray(value)
        ? `&${param}=${encodeURIComponent(value.join(filterValuesSeparator))}`
        : `&${param}=${encodeURIComponent(value)}`;
    })
    .join('');

  return (
    <div className="courses-wrapper">
      <CoursesHeader querySearchValue={router.query?.search as string} />

      <PageContent withSidebar={true}>
        <CoursesNav
          categories={filterData?.categories}
          customAttributes={filterData?.customAttributes}
          hasMandatoryCourses={filterData?.hasMandatoryCourses}
          languages={filterData?.languages}
        />

        <div className="content">
          {type === 'administered' ? (
            <CoursesViewAdministered
              queryParams={queryParams}
              onFilterDataReceived={(data) => setFilterData(data)}
            />
          ) : type === 'active' ? (
            <CoursesViewUser
              queryParams={queryParams}
              onFilterDataReceived={(data) => setFilterData(data)}
            />
          ) : type === 'available' ? (
            <CoursesViewAvailable
              queryParams={queryParams}
              onFilterDataReceived={(data) => setFilterData(data)}
            />
          ) : type === 'all' ? (
            <CoursesViewAllCourses
              queryParams={queryParams}
              onFilterDataReceived={(data) => setFilterData(data)}
            />
          ) : type === 'search' ? (
            <>
              <PageSectionHeader
                title={`${messages.commonSearch}: ${router.query.search}`}
              />

              <CoursesViewAllCourses queryParams={queryParams} />
            </>
          ) : null}
        </div>
      </PageContent>

      <style jsx>{`
        .content {
          flex-grow: 1;
          min-width: 0;
        }
      `}</style>
    </div>
  );
};

export default Courses;
